import React from 'react';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import {
  GenreHeader,
  GenreRender,
} from '@/pages/intelligence/components/TableComponents/components/TableGenre';
import TableChart from '@/pages/intelligence/components/TableComponents/components/TableChart';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import moment from 'moment';
import { get, isNumber } from 'lodash-es';

const BasisInfoColum = (formatMessage, onSortChange, apiParams, locale) => {
  return [
    // {
    //   key: 'gender',
    //   width: 320,
    //   align: 'left',
    //   header: (
    //     <CloumsCenter width={320} align={'left'}>
    //       <SortBy
    //         title={formatMessage({ id: `dbi_top_gender_breakdown` })}
    //         svgIcon={getDataSourceIcon('appannie')}
    //         onChange={(value) => onSortChange(value)}
    //         defaultKey={apiParams?.order_metric}
    //         defaultValue={apiParams?.order}
    //         list={[
    //           {
    //             sortMetric: 'gender_breakdown',
    //             key: 'gender_breakdown',
    //             text: 'Male',
    //             title: 'Male',
    //             orderType: 'gender',
    //           },
    //           // {
    //           //   sortMetric: 'female',
    //           //   key: 'female',
    //           //   text: 'Female',
    //           //   title: 'Female',
    //           //   orderType: 'gender',
    //           // },
    //         ]}
    //       ></SortBy>
    //     </CloumsCenter>
    //   ),
    //   render: (cvm: any) => {
    //     // 目前后台 age_breakdown和gender_breakdown字段值反了

    //     const ageBreakdown = get(
    //       cvm,
    //       'metric_map.gender_breakdown.history',
    //       [],
    //     );
    //     const colorList = ['#5086F3', '#58DEC7', '#F5D242'];
    //     const dataSourceList = ageBreakdown?.map((item, index) => {
    //       return {
    //         name: locale === 'zh-CN' ? item?.market_cn : item?.market_en,
    //         market: item?.market_en,
    //         color: colorList[index],
    //         title: locale === 'zh-CN' ? item?.market_cn : item?.market_en,
    //         value: `${(item?.value * 100)?.toFixed(2)}%`,
    //         lengendTitle: `${(item?.value * 100)?.toFixed(2)}%`,
    //         num: `${(item?.value * 100)?.toFixed(2)}%`,
    //       };
    //     });
       
    //     return (
    //       <TableChart
    //         tableData={{
    //           title: 'Gender',
    //           titleNow: 'Demographics%',
    //           list: dataSourceList,
    //         }}
    //       />
    //     );
    //   },
    // },
    // {
    //   key: 'age',
    //   width: 320,
    //   align: 'left',
    //   header: (
    //     <CloumsCenter width={320} align={'left'}>
    //       <SortBy
    //         title={formatMessage({ id: `dbi_top_age_breakdown` })}
    //         svgIcon={getDataSourceIcon('appannie')}
    //         list={[
    //           {
    //             orderType: 'age',
    //             sortMetric: 'lt25',
    //             key: 'lt25',
    //             text: 'Age < 25',
    //             title: 'Age < 25',
    //             color: '#5086F3',
    //           },
    //           {
    //             orderType: 'age',
    //             sortMetric: 'gte25_lte44',
    //             key: 'gte25_lte44',
    //             text: 'Age 25 - 44',
    //             title: 'Age 25 - 44',
    //             color: '#58DEC7',
    //           },
    //           {
    //             orderType: 'age',
    //             sortMetric: 'gt44',
    //             key: 'gt44',
    //             text: 'Age > 44',
    //             title: 'Age > 44',
    //             color: '#F5D242',
    //           },
    //         ]}
    //       ></SortBy>
    //     </CloumsCenter>
    //   ),
    //   render: (cvm: any) => {
    //     const genderBreakdown = get(
    //       cvm,
    //       'metric_map.age_breakdown.history',
    //       [],
    //     );
    //     const colorList = ['#5086F3', '#F17C86'];
    //     const dataSource = genderBreakdown
    //       ?.map((item) => ({
    //         name: locale === 'zh-CN' ? item?.market_cn : item?.market_en,
    //         market: item?.market_en,
    //         color: ['male', 'Male'].includes(item?.market_en)
    //           ? colorList[0]
    //           : colorList[1],
    //         title: locale === 'zh-CN' ? item?.market_cn : item?.market_en,
    //         value: `${(item?.value * 100)?.toFixed(2)}%`,
    //         lengendTitle: `${(item?.value * 100)?.toFixed(2)}%`,
    //         num: `${(item?.value * 100)?.toFixed(2)}%`,
    //       }))
    //       .sort((a, b) => b.market?.charCodeAt() - a.market?.charCodeAt());

    //     return (
    //       <TableChart
    //         tableData={{
    //           title: 'Age',
    //           titleNow: 'Demographics%',
    //           list: dataSource,
    //         }}
    //       />
    //     );
    //   },
    // },
    {
      key: 'developer',
      header: (
        <CloumsCenter width={140} align="left">
          <div className="header-other">
            {formatMessage({ id: 'dbi_developer' })}
          </div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 180,
      render: (cvm: any) => {
        const developer = get(cvm, 'metric_map.developer.value', '');
        return (
          <CloumsCenter width={140} align="left">
            <EllipsisHover text={developer} />
          </CloumsCenter>
        );
      },
    },
    {
      key: 'publisher',
      header: (
        <CloumsCenter width={180} align="left">
          <div className="header-other">
            {formatMessage({ id: 'dbi_publisher' })}
          </div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 180,
      render: (cvm: any) => {
        const publisher = get(cvm, 'metric_map.publisher.value', '');
        return (
          <CloumsCenter width={180} align="left">
            <EllipsisHover text={publisher} />
          </CloumsCenter>
        );
      },
    },
    {
      key: 'db_earlest_date',
      header: (
        <CloumsCenter width={200} align="left">
          <div className="header-other">
            {' '}
            {formatMessage({ id: 'dbi_benchmark_db_earliest_date' })}
          </div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 200,
      render: (cvm: any) => {
        return (
          <CloumsCenter width={200} align="left">
            {get(cvm, 'metric_map.db_earlest_date.value', '')}
          </CloumsCenter>
        );
      },
    },
    {
      key: 'db_release_date',
      header: (
        <CloumsCenter width={200} align="left">
          <div className="header-other">
            {formatMessage({ id: 'dbi_benchmark_db_release_date' })}
          </div>
        </CloumsCenter>
      ),

      align: 'center',
      width: 200,
      render: (cvm: any) => {
        const dbReleaseDate = get(cvm, 'metric_map.db_release_date.value', '');
        const targetDate = dbReleaseDate
          ? moment(dbReleaseDate).format('YYYY-MM-DD')
          : '';
        return (
          <CloumsCenter width={200} align="left">
            {targetDate}
          </CloumsCenter>
        );
      },
    },
    {
      key: 'avg_appstore_rating',
      header: (
        <CloumsCenter width={200} align="left">
          <div className="header-other">
            {formatMessage({ id: 'dbi_benchmark_avg_appStore_rating' })}
          </div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 200,
      render: (cvm: any) => {
        const avgAppStoreRating = get(
          cvm,
          'metric_map.avg_appstore_rating.value',
          '',
        );
        let targetValue = '-';
        switch (avgAppStoreRating) {
          case '0':
            targetValue = '0';
            break;
          case '-1':
            targetValue = '-';
            break;
          default:
            if (isNumber(Number(avgAppStoreRating))) {
              targetValue = isNaN(avgAppStoreRating)
                ? '-'
                : Number(avgAppStoreRating)?.toFixed(2);
            }
        }

        return (
          <CloumsCenter width={200} align="left">
            {targetValue}
          </CloumsCenter>
        );
      },
    },
    {
      key: 'avg_googleplay_rating',
      header: (
        <CloumsCenter width={200} align="left">
          <div className="header-other">
            {formatMessage({ id: 'dbi_benchmark_avg_googleplay_rating' })}
          </div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 200,
      render: (cvm: any) => {
        const avgGooglePlay = get(
          cvm,
          'metric_map.avg_googleplay_rating.value',
          '',
        );
        let targetValue = '-';
        switch (avgGooglePlay) {
          case '0':
            targetValue = '0';
            break;
          case '-1':
            targetValue = '-';
            break;
          default:
            if (isNumber(Number(avgGooglePlay))) {
              targetValue = isNaN(avgGooglePlay)
                ? '-'
                : Number(avgGooglePlay)?.toFixed(2);
            }
        }
        return (
          <CloumsCenter width={200} align="left">
            {targetValue}
          </CloumsCenter>
        );
      },
    },
    {
      key: 'genre',
      header: (
        <div className="header-other" style={{ display: 'flex' }}>
          <GenreHeader genreSource="iegg" />
        </div>
      ),
      width: 220,
      align: 'left',
      render: (cvm: any) => {
        const genre = get(cvm, 'metric_map.iegg_genre.value', '');
        const subGenre = get(cvm, 'metric_map.iegg_sub_genre.value', '');
        return (
          <GenreRender mainGenre={genre || '-'} subGenre={subGenre || '-'} />
        );
      },
    },
  ];
};

export default BasisInfoColum;
